import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import followSuggestion from '@/common/order.product-suggestions/follow-suggestion';

const { classNames } = Mobi2Go.helpers;

const ProductSuggestion = ({
    action,
    category,
    product,
    all_suggestions_count,
}) => {
    const [t] = useTranslation('order.product-suggestions');
    const suggestion = product || category;
    let menu_item = null;
    if (suggestion.menu_product) {
        menu_item = Mobi2Go.Menu.getProducts().getById(product.menu_product.id);
    }
    if (suggestion.menu_category) {
        menu_item = Mobi2Go.Menu.getCategories().getById(
            category.menu_category.id
        );
    }
    const onSuggestionClick = () => {
        followSuggestion(action, category, product, all_suggestions_count);
    };

    if (!menu_item) {
        return null;
    }
    return (
        <div
            data-item-name={menu_item.name}
            data-item={menu_item.id}
            className={`m2g-order-product-suggestions-item m2g-order-product-suggestions-item--${
                suggestion.menu_product ? 'product' : 'category'
            }`}
        >
            <div className="m2g-order-product-suggestions-item-image-container m2g-hidden">
                {menu_item.image_src && (
                    <img
                        className="m2g-order-product-suggestions-item-image m2g-image"
                        alt={menu_item.name}
                        src={menu_item.image_src}
                    />
                )}
            </div>
            <div
                role="button"
                tabIndex="0"
                onKeyPress={() => {}}
                onClick={onSuggestionClick}
                className="m2g-order-product-suggestions-item-name"
            >
                {menu_item.name}
            </div>
            <button
                type="button"
                onClick={onSuggestionClick}
                className={classNames(
                    'm2g-button',
                    'm2g-button--primary',
                    'm2g-text--small',
                    'm2g-order-product-suggestions-item-button'
                )}
            >
                {action === 'add_product' ? t('add') : t('view')}
            </button>
        </div>
    );
};

ProductSuggestion.propTypes = {
    action: PropTypes.string.isRequired,
    category: PropTypes.shape({
        menu_category: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
        }),
        quantity: PropTypes.number,
        discount: PropTypes.string,
    }),
    product: PropTypes.shape({
        menu_product: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
        }),
        quantity: PropTypes.number,
        discount: PropTypes.string,
    }),
    all_suggestions_count: PropTypes.number.isRequired,
};

ProductSuggestion.defaultProps = {
    category: null,
    product: null,
};

export default ProductSuggestion;
